"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./CheckboxGroup.css");
var _cdsUtils = require("@cbhq/cds-utils");
var _Checkbox = require("./Checkbox");
const _excluded = ["children", "label", "aria-labelledby", "selectedValues", "onChange", "name", "testID"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const checkboxStyles = "cds-checkboxStyles-cqq0sx6";
// Follows behavior describe in https://www.w3.org/TR/wai-aria-practices/examples/checkbox/checkbox-2/checkbox-2.html
const CheckboxGroupWithRef = /*#__PURE__*/(0, _react.forwardRef)(function CheckboxGroupWithRef(_ref, ref) {
  let children = _ref.children,
    label = _ref.label,
    ariaLabelledby = _ref['aria-labelledby'],
    selectedValues = _ref.selectedValues,
    onChange = _ref.onChange,
    name = _ref.name,
    testID = _ref.testID,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  if ((0, _cdsUtils.isDevelopment)() && !label && !ariaLabelledby) {
    // eslint-disable-next-line no-console
    console.warn('Please specify an aria label for the checkbox group.');
  }
  const checkboxIds = [];
  const optionCheckboxes = _react.Children.map(children, child => {
    var _child$props$id, _ref2;
    if (! /*#__PURE__*/(0, _react.isValidElement)(child) || child.type !== _Checkbox.Checkbox) {
      return child;
    }
    const value = child.props.value;
    if ((0, _cdsUtils.isDevelopment)() && typeof value === 'undefined') {
      // eslint-disable-next-line no-console
      console.error('Checkboxes inside CheckboxGroup should have values.');
    }
    const id = (_child$props$id = child.props.id) !== null && _child$props$id !== void 0 ? _child$props$id : ['checkbox-group', name, value].join('-');
    checkboxIds.push(id);
    return /*#__PURE__*/(0, _react.cloneElement)(child, {
      checked: (_ref2 = typeof value !== 'undefined' && selectedValues.has(value)) !== null && _ref2 !== void 0 ? _ref2 : child.props.checked,
      onChange,
      id,
      testID: testID ? `${testID}-${id}` : undefined
    });
  });

  // TODO (hannah): Update default styles once Caroline has the design ready. (Add default distance between
  // checkboxes.)
  return /*#__PURE__*/_react.default.createElement("fieldset", _extends({
    ref: ref,
    className: checkboxStyles,
    "data-testid": testID
  }, restProps), label, optionCheckboxes);
});
const CheckboxGroup = /*#__PURE__*/(0, _react.memo)(CheckboxGroupWithRef);
exports.CheckboxGroup = CheckboxGroup;